/**
 * Pure helper used by the BIBenefits container selector to determine whether
 * the current basket is eligible for BI Cash redemption.
 *
 * Returns `true` only when the basket carries a positive maxEligibleCBR; a
 * missing basket, a missing field, or a value of `0` all collapse to `false`.
 */
const isUserEligibleToRedeemBICashFromBasket = basket => (basket?.maxEligibleCBR ?? 0) > 0;

export default isUserEligibleToRedeemBICashFromBasket;
